import React from 'react'
import Aboutclient from './Aboutclient/Aboutclient'
import Clientlist from './Clientlist/Clientlist'

function Clients() {
  return (
    <>
      <Aboutclient />
      <Clientlist />
    </>
  )
}

export default Clients
